import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9a0d9514"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  "element-loading-background": "rgba(0, 0, 0, 0.5)",
  style: {"padding-top":"0px"}
}
const _hoisted_2 = { style: {"font-size":"14px","font-weight":"900","margin-top":"-5px"} }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = {
  key: 2,
  title: "订单已锁定",
  style: {"padding-left":"5px"}
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"40px","line-height":"40px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_9 = {
  key: 0,
  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"40px","line-height":"40px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_10 = { key: 0 }
const _hoisted_11 = {
  key: 1,
  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"40px","line-height":"40px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_12 = { style: {"width":"100% !important","overflow":"hidden","height":"40px","line-height":"40px"} }
const _hoisted_13 = {
  key: 0,
  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"40px","line-height":"40px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_14 = {
  key: 1,
  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"40px","line-height":"40px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"40px","line-height":"40px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_18 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"40px","line-height":"40px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_19 = {
  key: 0,
  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"40px","line-height":"40px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_20 = {
  key: 1,
  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"40px","line-height":"40px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"40px","line-height":"40px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_24 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"40px","line-height":"40px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_25 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"40px","line-height":"40px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_26 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"40px","line-height":"40px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_27 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"40px","line-height":"40px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_28 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"40px","line-height":"40px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = ["onClick"]
const _hoisted_31 = { style: {"height":"40px","line-height":"40px","float":"left","margin-top":"-15px"} }
const _hoisted_32 = { key: 0 }
const _hoisted_33 = { key: 1 }
const _hoisted_34 = { style: {"float":"right","height":"40px","line-height":"40px","margin-top":"-10px","margin-right":"-10px"} }
const _hoisted_35 = { key: 0 }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"40px","line-height":"40px","font-weight":"900"} }, "请选择分摊方式以及币制换算等信息", -1))
const _hoisted_37 = { style: {"padding-top":"3px","padding-left":"3px"} }
const _hoisted_38 = { style: {"padding-top":"3px","padding-left":"3px"} }
const _hoisted_39 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"40px","line-height":"40px"} }
const _hoisted_40 = {
  key: 0,
  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"40px","line-height":"40px"}
}
const _hoisted_41 = {
  key: 1,
  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"40px","line-height":"40px"}
}
const _hoisted_42 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"40px","line-height":"40px"} }
const _hoisted_43 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"40px","line-height":"40px"} }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f56c6c"} }, "*", -1))
const _hoisted_45 = { style: {"cursor":"pointer","color":"#fe995b","width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"46px","line-height":"40px"} }
const _hoisted_46 = { key: 1 }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"40px","line-height":"40px","font-weight":"900"} }, " 您希望将费用分摊到哪几个委托中，请选择 ", -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {} }, " 提示：建议在货物确认出库后再进行费用分摊，点击Booking no可查看出入库具体情况；如货物未全部出运，请先至《出入库管理》中进行调整后再继续分摊； ", -1))
const _hoisted_49 = ["onClick", "title"]
const _hoisted_50 = ["title"]
const _hoisted_51 = {
  key: 1,
  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"40px","line-height":"40px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_52 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"40px","line-height":"40px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_53 = ["title"]
const _hoisted_54 = {
  key: 1,
  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"40px","line-height":"40px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_55 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"40px","line-height":"40px"} }
const _hoisted_56 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"40px","line-height":"40px"} }
const _hoisted_57 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"40px","line-height":"40px"} }
const _hoisted_58 = {
  key: 0,
  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"40px","line-height":"40px"}
}
const _hoisted_59 = {
  key: 1,
  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"40px","line-height":"40px"}
}
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both","height":"90px"} }, null, -1))
const _hoisted_61 = { style: {"clear":"both"} }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"40px","line-height":"40px","float":"left","margin-top":"-15px"} }, [
  /*#__PURE__*/_createElementVNode("span", null, "批量修改汇率")
], -1))
const _hoisted_63 = { style: {"float":"right","height":"40px","line-height":"40px","margin-top":"-10px","margin-right":"-10px"} }
const _hoisted_64 = { style: {"clear":"both","margin-top":"20px"} }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"40px","line-height":"40px","float":"left","margin-top":"-15px"} }, [
  /*#__PURE__*/_createElementVNode("span", null, "批量修改材积比")
], -1))
const _hoisted_66 = { style: {"float":"right","height":"40px","line-height":"40px","margin-top":"-10px","margin-right":"-10px"} }
const _hoisted_67 = { style: {"clear":"both","margin-top":"20px"} }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"40px","line-height":"40px","float":"left","margin-top":"-15px"} }, [
  /*#__PURE__*/_createElementVNode("span", null, "批量修改最低计费标准")
], -1))
const _hoisted_69 = { style: {"float":"right","height":"40px","line-height":"40px","margin-top":"-10px","margin-right":"-10px"} }
const _hoisted_70 = { style: {"clear":"both","margin-top":"20px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_miezz_menu_tab = _resolveComponent("miezz-menu-tab")!
  const _component_Lock = _resolveComponent("Lock")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_Plus = _resolveComponent("Plus")!
  const _component_Minus = _resolveComponent("Minus")!
  const _component_RefreshLeft = _resolveComponent("RefreshLeft")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_miezz_button_bar = _resolveComponent("miezz-button-bar")!
  const _component_CloseBold = _resolveComponent("CloseBold")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_QuestionFilled = _resolveComponent("QuestionFilled")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_Edit = _resolveComponent("Edit")!
  const _component_miezz_input = _resolveComponent("miezz-input")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_miezz_currency = _resolveComponent("miezz-currency")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_miezz_menu_tab, {
      modelValue: _ctx.menuTab,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.menuTab) = $event))
    }, null, 8, ["modelValue"]),
    _createVNode(_component_el_card, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.dto.Code!=null && _ctx.dto.Code!=undefined && _ctx.dto.Code!='')
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onOrder())),
                style: {"color":"#fe995b","cursor":"pointer"}
              }, "订单编号：" + _toDisplayString(_ctx.isString(_ctx.dto.Code)), 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_3, "订单编号：" + _toDisplayString(_ctx.isString(_ctx.dto.Code)), 1)),
          (_ctx.dto.IsLock == true)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_Lock)
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_el_form, {
          ref: "$billRuleForm",
          model: _ctx.dto
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table, {
              data: _ctx.dto.Items,
              ref: "poolBillTable",
              stripe: "",
              style: {"width":"100%","margin-top":"15px"},
              "row-class-name": _ctx.tableRowClassName,
              "header-cell-style": { 'text-align': 'left' },
              "cell-style": { 'text-align': 'left' },
              onSelectionChange: _ctx.handleSelectionChange,
              "tree-props": {children: 'Child', hasChildren: 'hasChildren'},
              "row-key": "Id",
              "default-expand-all": true,
              "row-style": _ctx.rowStyle,
              border: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  type: "selection",
                  width: "55",
                  selectable: _ctx.selectable
                }, null, 8, ["selectable"]),
                _createVNode(_component_el_table_column, {
                  prop: "scope.row.Pool",
                  label: "Booking No",
                  width: "150px",
                  "show-overflow-tooltip": true
                }, {
                  default: _withCtx((scope) => [
                    (scope.row.Pool)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.isString(scope.row.Pool.BookingNo,scope.row)), 1))
                      : (scope.row.ChildCount<=0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_6, " 未分摊 "))
                        : (_openBlock(), _createElementBlock("span", _hoisted_7, "—"))
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "scope.row.SupplierLabel",
                  label: "供应商",
                  "show-overflow-tooltip": true
                }, {
                  default: _withCtx((scope) => [
                    _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.isString(scope.row.SupplierLabel)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "scope.row.CostId",
                  label: "费用名称",
                  "show-overflow-tooltip": true
                }, {
                  default: _withCtx((scope) => [
                    (scope.row.Cost!=null && scope.row.Cost!=undefined)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                          _createTextVNode(_toDisplayString(_ctx.isString(scope.row.Cost.NameZh,scope.row)), 1),
                          (scope.row.FromId!=undefined)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_10, "分摊"))
                            : _createCommentVNode("", true)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_11, " 暂无数据 "))
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "scope.row.CurrencySystem",
                  label: "币制",
                  width: "60px",
                  "show-overflow-tooltip": true
                }, {
                  default: _withCtx((scope) => [
                    _createElementVNode("div", _hoisted_12, [
                      (scope.row.CurrencySystem)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_ctx.isString(scope.row.CurrencySystem.Code,scope.row)), 1))
                        : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                            (scope.row.FromId!=undefined)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_15, "—"))
                              : (_openBlock(), _createElementBlock("span", _hoisted_16, "暂无数据"))
                          ]))
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "scope.row.UnitPrice",
                  label: "单价",
                  width: "100px",
                  "show-overflow-tooltip": true
                }, {
                  default: _withCtx((scope) => [
                    _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.isString(scope.row.UnitPrice,scope.row)), 1)
                  ]),
                  _: 1
                }),
                (_ctx.currencySystem?.ShowTaxRate)
                  ? (_openBlock(), _createBlock(_component_el_table_column, {
                      key: 0,
                      prop: "scope.row.TaxRate",
                      label: "税率%",
                      width: "100px",
                      "show-overflow-tooltip": true
                    }, {
                      default: _withCtx((scope) => [
                        _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.isString(scope.row.TaxRate,scope.row)), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_table_column, {
                  prop: "scope.row.FirstChargeUnitId",
                  label: "计价单位",
                  width: "120px",
                  "show-overflow-tooltip": true
                }, {
                  default: _withCtx((scope) => [
                    (scope.row.FirstChargeUnit!=null && scope.row.FirstChargeUnit!=undefined)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(_ctx.isString(scope.row.FirstChargeUnit.Code,scope.row)), 1))
                      : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                          (scope.row.FromId!=undefined)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_21, "—"))
                            : (_openBlock(), _createElementBlock("span", _hoisted_22, "暂无数据"))
                        ]))
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "scope.row.FirstChargeUnitId",
                  label: "数量",
                  width: "120px",
                  "show-overflow-tooltip": true
                }, {
                  default: _withCtx((scope) => [
                    _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.isString(scope.row.FirstChargeUnitNumber,scope.row)), 1)
                  ]),
                  _: 1
                }),
                (_ctx.currencySystem?.ShowTaxRate)
                  ? (_openBlock(), _createBlock(_component_el_table_column, {
                      key: 1,
                      prop: "scope.row.TaxAmount",
                      label: "税额",
                      width: "120px",
                      "show-overflow-tooltip": true
                    }, {
                      default: _withCtx((scope) => [
                        _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.isString(scope.row.TaxAmount,scope.row)), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_table_column, {
                  prop: "scope.row.TotalPrice",
                  label: "单项合计",
                  width: "120px",
                  "show-overflow-tooltip": true
                }, {
                  default: _withCtx((scope) => [
                    _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.isString(scope.row.TotalPrice,scope.row)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "scope.row.Remark",
                  label: "备注",
                  "show-overflow-tooltip": true
                }, {
                  default: _withCtx((scope) => [
                    _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.isString(scope.row.Remark,scope.row)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "scope.row.StartDateString",
                  label: "记账起始时间",
                  width: "150px",
                  "show-overflow-tooltip": true
                }, {
                  default: _withCtx((scope) => [
                    _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.isString(scope.row.StartDateString,scope.row)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "scope.row.AccountPeriod",
                  label: "账期（天数）",
                  width: "150px",
                  "show-overflow-tooltip": true
                }, {
                  default: _withCtx((scope) => [
                    _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.isString(scope.row.AccountPeriod,scope.row)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "Executor",
                  label: "操作",
                  width: "120"
                }, {
                  default: _withCtx((scope) => [
                    (scope.row.ChildCount>0 && scope.row.IsOpen==false)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          onClick: ($event: any) => (_ctx.onDisplayChild(scope.row))
                        }, [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_Plus)
                            ]),
                            _: 1
                          })
                        ], 8, _hoisted_29))
                      : _createCommentVNode("", true),
                    (scope.row.ChildCount>0 && scope.row.IsOpen==true)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 1,
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onHideChild()))
                        }, [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_Minus)
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true),
                    (scope.row.ChildCount>0)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 2,
                          onClick: ($event: any) => (_ctx.onRevoke(scope.row)),
                          style: {"margin-left":"20px"}
                        }, [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_RefreshLeft)
                            ]),
                            _: 1
                          })
                        ], 8, _hoisted_30))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data", "row-class-name", "onSelectionChange", "row-style"])
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }),
    _createVNode(_component_miezz_button_bar, {
      modelValue: _ctx.bottomButtons,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.bottomButtons) = $event)),
      isFix: true,
      right: '46%',
      onHandleClick: _ctx.handleClick
    }, null, 8, ["modelValue", "onHandleClick"]),
    (_ctx.form != undefined)
      ? (_openBlock(), _createBlock(_component_el_dialog, {
          key: 0,
          modelValue: _ctx.form.Visiable,
          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.form.Visiable) = $event)),
          "show-close": false,
          style: {"width":"80%"},
          top: "10px",
          "close-on-click-modal": false,
          "close-on-press-escape": false,
          "append-to-body": true
        }, {
          header: _withCtx(({ close }) => [
            _createElementVNode("div", _hoisted_31, [
              (_ctx.form.Step==1)
                ? (_openBlock(), _createElementBlock("span", _hoisted_32, "分摊步骤一"))
                : _createCommentVNode("", true),
              (_ctx.form.Step==2)
                ? (_openBlock(), _createElementBlock("span", _hoisted_33, "分摊步骤二"))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_34, [
              _createVNode(_component_el_icon, {
                style: {"cursor":"pointer"},
                onClick: close
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_CloseBold)
                ]),
                _: 2
              }, 1032, ["onClick"])
            ])
          ]),
          default: _withCtx(() => [
            (_ctx.form.Step == 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                  _hoisted_36,
                  _createVNode(_component_el_form, {
                    model: _ctx.form,
                    ref: "$sharRuleForm",
                    "label-width": "0px"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        "label-width": "150px",
                        label: "分摊方式",
                        style: {"width":"50% !important","float":"left"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.form.Type,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.Type) = $event)),
                            filterable: "",
                            placeholder: "请选择",
                            onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onChangeType()))
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.EnumBillShareTypeOption, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.Value,
                                  label: item.Label,
                                  value: item.Value
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      (_ctx.form.Type == 40)
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 0,
                            "label-width": "150px",
                            label: "材积比",
                            style: {"width":"50% !important","float":"left"},
                            prop: 'VolumeRatio',
                            rules: [
                                                {
                                                required: true,
                                                message: '信息不能为空',
                                                trigger: 'change',
                                                },
                                            ]
                          }, {
                            label: _withCtx(() => [
                              _createTextVNode(" 材积比 "),
                              _createElementVNode("span", _hoisted_37, [
                                _createVNode(_component_el_icon, {
                                  style: {"color":"red","font-size":"18px"},
                                  title: "示例：材积比167代表1m³按167kgs计费"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_QuestionFilled)
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.form.VolumeRatio,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.VolumeRatio) = $event)),
                                placeholder: "请填写",
                                onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onChangeFormVolumeRatio()))
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.form.Type == 20 || _ctx.form.Type == 30)
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 1,
                            "label-width": "150px",
                            label: "材积比",
                            style: {"width":"50% !important","float":"left"}
                          }, {
                            label: _withCtx(() => [
                              _createTextVNode(" 材积比 "),
                              _createElementVNode("span", _hoisted_38, [
                                _createVNode(_component_el_icon, {
                                  style: {"color":"red","font-size":"18px"},
                                  title: "示例：材积比167代表1m³按167kgs计费"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_QuestionFilled)
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.form.VolumeRatio,
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.VolumeRatio) = $event)),
                                placeholder: "请填写",
                                onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.onChangeFormVolumeRatio()))
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.form.Type == 40)
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 2,
                            "label-width": "150px",
                            label: "单件最低计费标准",
                            style: {"width":"50% !important","float":"left"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.form.OneMiniStandard,
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.OneMiniStandard) = $event)),
                                placeholder: "请填写",
                                onChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.onChangeFormOneMiniStandard()))
                              }, {
                                append: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.form.MiniStandardUnit), 1)
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.form.Type == 40 || _ctx.form.Type == 20 || _ctx.form.Type ==30)
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 3,
                            "label-width": "150px",
                            label: _ctx.form.Type == 40?'单票最低计费标准':'最低计费标准',
                            style: {"width":"50% !important","float":"left"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.form.MiniStandard,
                                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.form.MiniStandard) = $event)),
                                placeholder: "请填写",
                                onChange: _cache[13] || (_cache[13] = ($event: any) => (_ctx.onChangeFormMiniStandard()))
                              }, {
                                append: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.form.MiniStandardUnit), 1)
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }, 8, ["label"]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_el_form_item, {
                        "label-width": "0px",
                        label: "",
                        style: {"clear":"both"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_table, {
                            data: _ctx.form.Froms,
                            ref: "fromBillTable",
                            stripe: "",
                            "header-cell-style": { 'text-align': 'left' },
                            "cell-style": { 'text-align': 'left' }
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_table_column, {
                                prop: "scope.row.SupplierLabel",
                                label: "供应商",
                                "show-overflow-tooltip": true
                              }, {
                                default: _withCtx((scope) => [
                                  _createElementVNode("div", _hoisted_39, _toDisplayString(_ctx.isString(scope.row.SupplierLabel)), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_table_column, {
                                prop: "scope.row.Cost",
                                label: "费用名称",
                                "show-overflow-tooltip": true
                              }, {
                                default: _withCtx((scope) => [
                                  (scope.row.Cost!=undefined && scope.row.Cost!=null)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_40, _toDisplayString(_ctx.isString(scope.row.Cost.NameZh)), 1))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_41, " 暂无数据 "))
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_table_column, {
                                prop: "scope.row.TotalPrice",
                                label: "金额",
                                width: "150px",
                                "show-overflow-tooltip": true
                              }, {
                                default: _withCtx((scope) => [
                                  _createElementVNode("div", _hoisted_42, _toDisplayString(_ctx.isString(scope.row.CurrencySystem.Code)) + _toDisplayString(_ctx.isString(scope.row.TotalPrice)), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_table_column, {
                                prop: "scope.row.ShareCurrencySystem",
                                label: "换算币制",
                                width: "150px",
                                "show-overflow-tooltip": true
                              }, {
                                header: _withCtx(() => [
                                  _createTextVNode(" 换算币制 ")
                                ]),
                                default: _withCtx((scope) => [
                                  _createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.isString(scope.row.ShareCurrencySystem.Code)), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_table_column, {
                                prop: "scope.row.Rate",
                                label: "汇率",
                                width: "150px"
                              }, {
                                header: _withCtx(() => [
                                  _hoisted_44,
                                  _createTextVNode(" 汇率 "),
                                  (_ctx.isBatchRate==true)
                                    ? (_openBlock(), _createElementBlock("span", {
                                        key: 0,
                                        style: {"cursor":"pointer","margin-left":"2px","color":"#00a5fb"},
                                        onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.onBatchRate()))
                                      }, [
                                        _createVNode(_component_el_icon, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_Edit)
                                          ]),
                                          _: 1
                                        })
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                default: _withCtx((scope) => [
                                  _createElementVNode("div", _hoisted_45, [
                                    _createVNode(_component_el_form_item, {
                                      label: "",
                                      "label-width": "0px",
                                      prop: 'Froms.' + scope.$index + '.Rate',
                                      rules: [
                                                {
                                                required: true,
                                                message: '信息不能为空',
                                                trigger: 'blur',
                                                },
                                            ]
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_miezz_input, {
                                          placeholder: "请填写",
                                          disabled: (scope.row.ShareCurrencySystemId == scope.row.CurrencySystemId && scope.row.CurrencySystemId!=null && scope.row.CurrencySystemId !=undefined)?true:false,
                                          onBlur: ($event: any) => (_ctx.onChangeRate(scope.$index)),
                                          modelValue: scope.row.Rate,
                                          "onUpdate:modelValue": ($event: any) => ((scope.row.Rate) = $event)
                                        }, null, 8, ["disabled", "onBlur", "modelValue", "onUpdate:modelValue"])
                                      ]),
                                      _: 2
                                    }, 1032, ["prop"])
                                  ])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["data"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["model"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.form.Step == 2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                  _hoisted_47,
                  _hoisted_48,
                  _createVNode(_component_el_form, {
                    model: _ctx.form,
                    ref: "$toRuleForm"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        "label-width": "0px",
                        label: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_table, {
                            onSelectionChange: _ctx.handleSelectionChangeTo,
                            data: _ctx.form.Tos,
                            ref: "toBillTable",
                            stripe: "",
                            "header-cell-style": { 'text-align': 'left' },
                            "cell-style": { 'text-align': 'left' }
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_table_column, {
                                type: "selection",
                                width: "55",
                                selectable: _ctx.selectableShare
                              }, null, 8, ["selectable"]),
                              _createVNode(_component_el_table_column, {
                                prop: "scope.row.Pool",
                                label: "Booking No",
                                "show-overflow-tooltip": true
                              }, {
                                default: _withCtx((scope) => [
                                  (scope.row.Pool!=null && scope.row.Pool!=undefined)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 0,
                                        onClick: ($event: any) => (_ctx.onBookingNo(scope.row)),
                                        style: {"cursor":"pointer","color":"#fe995b","width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"40px","line-height":"40px","text-overflow":"ellipsis","white-space":"nowrap"},
                                        title: scope.row.Pool.BookingNo
                                      }, [
                                        _createElementVNode("span", {
                                          title: scope.row.IsSave==true?'该委托书已被锁定':''
                                        }, [
                                          (scope.row.IsSave==true)
                                            ? (_openBlock(), _createBlock(_component_el_icon, { key: 0 }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_Lock)
                                                ]),
                                                _: 1
                                              }))
                                            : _createCommentVNode("", true)
                                        ], 8, _hoisted_50),
                                        _createTextVNode(" " + _toDisplayString(_ctx.isString(scope.row.Pool.BookingNo)), 1)
                                      ], 8, _hoisted_49))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_51, " 暂无数据 "))
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_table_column, {
                                prop: "scope.row.PoolRemark",
                                label: "备注",
                                "show-overflow-tooltip": true
                              }, {
                                default: _withCtx((scope) => [
                                  _createElementVNode("div", _hoisted_52, _toDisplayString(_ctx.isString(scope.row.PoolRemark)), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_table_column, {
                                prop: "scope.row.Pool",
                                label: "委托人",
                                "show-overflow-tooltip": true
                              }, {
                                default: _withCtx((scope) => [
                                  (scope.row.Pool!=null && scope.row.Pool!=undefined)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 0,
                                        style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"40px","line-height":"40px","text-overflow":"ellipsis","white-space":"nowrap"},
                                        title: scope.row.Pool.ClientCompanyLabel
                                      }, _toDisplayString(_ctx.isString(scope.row.Pool.ClientCompanyLabel)), 9, _hoisted_53))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_54, " 暂无数据 "))
                                ]),
                                _: 1
                              }),
                              (_ctx.form.Type == 20)
                                ? (_openBlock(), _createBlock(_component_el_table_column, {
                                    key: 0,
                                    prop: "scope.row.InStockGrossWeight",
                                    label: "入库毛重/KGS",
                                    width: "150px",
                                    "show-overflow-tooltip": true
                                  }, {
                                    default: _withCtx((scope) => [
                                      _createElementVNode("div", _hoisted_55, _toDisplayString(_ctx.isString(scope.row.InStockGrossWeight)), 1)
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              (_ctx.form.Type == 30)
                                ? (_openBlock(), _createBlock(_component_el_table_column, {
                                    key: 1,
                                    prop: "scope.row.InStockVolume",
                                    label: "入库体积/CBM",
                                    width: "150px",
                                    "show-overflow-tooltip": true
                                  }, {
                                    default: _withCtx((scope) => [
                                      _createElementVNode("div", _hoisted_56, _toDisplayString(_ctx.isString(scope.row.InStockVolume)), 1)
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              (_ctx.form.Type == 40)
                                ? (_openBlock(), _createBlock(_component_el_table_column, {
                                    key: 2,
                                    prop: "scope.row.ChildWeight",
                                    label: "入库计费重量/KGS",
                                    width: "150px",
                                    "show-overflow-tooltip": true
                                  }, {
                                    default: _withCtx((scope) => [
                                      _createElementVNode("div", _hoisted_57, _toDisplayString(_ctx.isString(scope.row.ChildWeight)), 1)
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              (_ctx.form.Type != 10)
                                ? (_openBlock(), _createBlock(_component_el_table_column, {
                                    key: 3,
                                    prop: "scope.row.OutStockWeight",
                                    label: "是否已全部出库",
                                    width: "150px",
                                    "show-overflow-tooltip": true
                                  }, {
                                    default: _withCtx((scope) => [
                                      (scope.row.IsAllOutStock == true)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_58, " 是 "))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_59, " 否 "))
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }, 8, ["onSelectionChange", "data"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["model"])
                ]))
              : _createCommentVNode("", true),
            _hoisted_60,
            _createElementVNode("div", _hoisted_61, [
              _createVNode(_component_miezz_button_bar, {
                modelValue: _ctx.shareBottomButtons,
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.shareBottomButtons) = $event)),
                isBackground: true,
                onHandleClick: _ctx.handleClickShare
              }, null, 8, ["modelValue", "onHandleClick"])
            ])
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    (_ctx.batchRateForm != undefined)
      ? (_openBlock(), _createBlock(_component_el_dialog, {
          key: 1,
          modelValue: _ctx.batchRateForm.Visiable,
          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.batchRateForm.Visiable) = $event)),
          "show-close": false,
          style: {"width":"40%"},
          "close-on-click-modal": false,
          "close-on-press-escape": false,
          "append-to-body": true
        }, {
          header: _withCtx(({ close }) => [
            _hoisted_62,
            _createElementVNode("div", _hoisted_63, [
              _createVNode(_component_el_icon, {
                style: {"cursor":"pointer"},
                onClick: close
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_CloseBold)
                ]),
                _: 2
              }, 1032, ["onClick"])
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createVNode(_component_el_form, {
                model: _ctx.batchRateForm,
                ref: "$batchRateForm",
                "label-width": "0px"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    "label-width": "150px",
                    label: "汇率",
                    prop: "Rate",
                    rules: [
                                                {
                                                required: true,
                                                message: '信息不能为空',
                                                trigger: 'blur',
                                                },
                                            ]
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.batchRateForm.Rate,
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.batchRateForm.Rate) = $event)),
                        placeholder: "请填写",
                        onBlur: _cache[18] || (_cache[18] = ($event: any) => (_ctx.onChangeBatchRate()))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"])
            ]),
            _createElementVNode("div", _hoisted_64, [
              _createVNode(_component_miezz_button_bar, {
                modelValue: _ctx.batchRateBottomButtons,
                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.batchRateBottomButtons) = $event)),
                isBackground: true,
                onHandleClick: _ctx.handleClickBatchRate
              }, null, 8, ["modelValue", "onHandleClick"])
            ])
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    (_ctx.batchVolumeRatioForm != undefined)
      ? (_openBlock(), _createBlock(_component_el_dialog, {
          key: 2,
          modelValue: _ctx.batchVolumeRatioForm.Visiable,
          "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.batchVolumeRatioForm.Visiable) = $event)),
          "show-close": false,
          style: {"width":"40%"},
          "close-on-click-modal": false,
          "close-on-press-escape": false,
          "append-to-body": true
        }, {
          header: _withCtx(({ close }) => [
            _hoisted_65,
            _createElementVNode("div", _hoisted_66, [
              _createVNode(_component_el_icon, {
                style: {"cursor":"pointer"},
                onClick: close
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_CloseBold)
                ]),
                _: 2
              }, 1032, ["onClick"])
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createVNode(_component_el_form, {
                model: _ctx.batchVolumeRatioForm,
                ref: "$batchVolumeRatioForm",
                "label-width": "0px"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    "label-width": "150px",
                    label: "材积比",
                    prop: "VolumeRatio",
                    rules: [
                                                {
                                                required: true,
                                                message: '信息不能为空',
                                                trigger: 'blur',
                                                },
                                            ]
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.batchVolumeRatioForm.VolumeRatio,
                        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.batchVolumeRatioForm.VolumeRatio) = $event)),
                        placeholder: "请填写",
                        onBlur: _cache[22] || (_cache[22] = ($event: any) => (_ctx.onChangeBatchVolumeRatio()))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"])
            ]),
            _createElementVNode("div", _hoisted_67, [
              _createVNode(_component_miezz_button_bar, {
                modelValue: _ctx.batchVolumeRatioBottomButtons,
                "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.batchVolumeRatioBottomButtons) = $event)),
                isBackground: true,
                onHandleClick: _ctx.handleClickBatchVolumeRatio
              }, null, 8, ["modelValue", "onHandleClick"])
            ])
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    (_ctx.batchMiniStandardRatioForm != undefined)
      ? (_openBlock(), _createBlock(_component_el_dialog, {
          key: 3,
          modelValue: _ctx.batchMiniStandardRatioForm.Visiable,
          "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.batchMiniStandardRatioForm.Visiable) = $event)),
          "show-close": false,
          style: {"width":"40%"},
          "close-on-click-modal": false,
          "close-on-press-escape": false,
          "append-to-body": true
        }, {
          header: _withCtx(({ close }) => [
            _hoisted_68,
            _createElementVNode("div", _hoisted_69, [
              _createVNode(_component_el_icon, {
                style: {"cursor":"pointer"},
                onClick: close
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_CloseBold)
                ]),
                _: 2
              }, 1032, ["onClick"])
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createVNode(_component_el_form, {
                model: _ctx.batchMiniStandardRatioForm,
                ref: "$batchMiniStandardRatioForm",
                "label-width": "0px"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    "label-width": "150px",
                    label: "最低计费标准",
                    prop: "MiniStandardRatio",
                    rules: [
                                                {
                                                required: true,
                                                message: '信息不能为空',
                                                trigger: 'blur',
                                                },
                                            ]
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.batchMiniStandardRatioForm.MiniStandardRatio,
                        "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.batchMiniStandardRatioForm.MiniStandardRatio) = $event)),
                        placeholder: "请填写",
                        onBlur: _cache[26] || (_cache[26] = ($event: any) => (_ctx.onChangeBatchMiniStandardRatio()))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"])
            ]),
            _createElementVNode("div", _hoisted_70, [
              _createVNode(_component_miezz_button_bar, {
                modelValue: _ctx.batchMiniStandardRatioBottomButtons,
                "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.batchMiniStandardRatioBottomButtons) = $event)),
                isBackground: true,
                onHandleClick: _ctx.handleClickBatchMiniStandardRatio
              }, null, 8, ["modelValue", "onHandleClick"])
            ])
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    _createVNode(_component_miezz_currency, {
      defaultRate: '美元',
      isRate: false,
      defaultCurrency: '美元',
      ref: "Currency",
      onOnSelectCurrency: _ctx.onSelectCurrency
    }, null, 8, ["onOnSelectCurrency"])
  ])), [
    [
      _directive_loading,
      _ctx.isLoading,
      void 0,
      {
        fullscreen: true,
        lock: true
      }
    ]
  ])
}